import clsx from "clsx";
import React from "react";
import { NavLink } from "react-router-dom";

type RoutedTabsLinksProps = React.HTMLProps<HTMLDivElement> & {
  children?: React.ReactNode;
  contentClassName?: string;
  containerClassName?: string;
  activeTabName?: string;
  tabLinks: {
    label: React.ReactNode;
    path: string;
    icon?: React.ReactNode;
    search?: string;
    key?: string;
  }[];
};

export default function TabbedLinks({
  children,
  className,
  contentClassName = "bg-white border border-t-0 border-gray-300 flex-1 overflow-y-auto p-2",
  containerClassName = "px-4 py-6 bg-white",
  tabLinks,
  activeTabName,
  ...rest
}: RoutedTabsLinksProps) {
  return (
    <div className={clsx("flex min-h-0 flex-1 flex-col", containerClassName)}>
      <div
        className={`flex flex-wrap border-b border-gray-300 ${className}`}
        aria-label="Tabs"
        {...rest}
      >
        {tabLinks.map(({ label, path, key, search, icon }) => (
          <NavLink
            className={({ isActive }) =>
              clsx(
                "mb-[-2px] cursor-pointer rounded-t-md border border-b-0 border-gray-300 px-4 py-2 text-sm font-medium hover:text-gray-900",
                isActive || activeTabName === key
                  ? "bg-white text-gray-900"
                  : "border-transparent text-gray-500"
              )
            }
            key={path}
            to={{
              pathname: path,
              search
            }}
            end
          >
            <div className="flex flex-row items-center space-x-1">
              {icon} <span>{label}</span>
            </div>
          </NavLink>
        ))}
      </div>
      <div className={clsx("flex flex-col", contentClassName)}>{children}</div>
    </div>
  );
}
